import { useIntl } from 'react-intl';
import cx from 'clsx';
import { SkeletonLoader } from '@repo/design-system-kit/components/skeleton-loader/skeleton-loader';
import styles from './fourthline-loading.module.css';

export function FourthlineLoading({ isFullHeight = true }: { isFullHeight?: boolean }) {
  const { formatMessage } = useIntl();
  return (
    <div
      aria-label={formatMessage({
        id: 'generic.loading-screen.title',
        defaultMessage: 'Just a few seconds...',
      })}
      className={cx(styles.container, isFullHeight && styles.fullHeight)}
      data-testid="fourthline-loading"
      role="status"
    >
      <header className={styles.header}>
        <div className={styles.illustration}>
          <SkeletonLoader.Block style={{ width: '200px', height: '200px', borderRadius: '8px' }} />
        </div>
        <SkeletonLoader.Header style={{ width: '400px' }} />
        <div className={styles.subtitle}>
          <SkeletonLoader.Line style={{ width: '100%' }} />
          <SkeletonLoader.Line style={{ width: '90%' }} />
        </div>
      </header>

      <div className={styles.bulletPoints}>
        {Array.from({ length: 3 }, (_, index) => (
          <div className={styles.bulletPoint} key={index}>
            <SkeletonLoader.Block style={{ width: '16px', height: '16px', borderRadius: '2px' }} />
            <SkeletonLoader.Line style={{ width: '100%' }} />
          </div>
        ))}
      </div>

      <div className={styles.termsSection}>
        <div className={styles.disclaimer}>
          <SkeletonLoader.Line style={{ width: '100%' }} />
          <SkeletonLoader.Line style={{ width: '100%' }} />
          <SkeletonLoader.Line style={{ width: '70%' }} />
        </div>

        <div className={styles.checkbox}>
          <SkeletonLoader.Block style={{ width: '16px', height: '16px', borderRadius: '2px' }} />
          <SkeletonLoader.Line style={{ width: '200px' }} />
        </div>
      </div>

      <SkeletonLoader.Block style={{ width: '100%', height: '40px', borderRadius: '4px' }} />
    </div>
  );
}
